import React, { useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axios/axios";
import FormBuilder from "../Components/FormBuilder";
import { fetchCMS } from "../fetch/cms/main";
import { fetchFreelancerProfile } from "../fetch/freelancer/profile";
import { fetchInput } from "../fetch/input/main";
import { fetchProfile } from "../fetch/profile/myProfile";
import { queryClient } from "../routes/Reactquery";
import { compareObjects } from "../utils/helper";
import { toast } from "react-toastify";
import { EmailCnf } from "../Components/Profile/EmailCnf";
import { handleScrollDown } from "../helper/scroll";
import SecureComponent from "../Components/SecureComponent";
import { VerifyEmailButton } from "../Components/Profile/VerifyEmailButton";

function Container() {
  return (
    <>
      <SecureComponent>
        <>
          <Profile />
          <Password />
          <DeleteAccount />
          {/* <EmailCnf /> */}
        </>
      </SecureComponent>
    </>
  );
}
function Profile() {
  const navigation = useNavigate();
  const [user, setUser] = useState({});

  const { data, isLoading, error } = fetchProfile();
  const { data: freelancer } = fetchFreelancerProfile();

  const {
    data: inputAPI,
    isLoading: inputIsLoading,
    error: inputError,
  } = fetchInput();

  function ChangeInput(e) {
    e.preventDefault();
    setUser({ ...user, [e.target.name]: e.target.value });
  }

  if (!isLoading && !user) {
    if (data == null) navigation("/login");
    // if (data?.data?.user) setUser(data?.data?.user);
  }
  const profileMutation = useMutation(updateProfile, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(["profile"], ["freelancerprofile"]);
      await queryClient.invalidateQueries(["freelancerprofile"]);
    },
  });

  function sync() {
    let flag = true;
    if (!!Object?.keys(user).length) {
      Object?.keys(user)?.map((key) => {
        if (user?.[key] != data?.data?.user?.[key]) flag = false;
      });
      return flag;
    } else return true;
  }
  const isInSync = sync();
  const approved = freelancer?.data?.isUpdate?.approve;
  const mailVerified = freelancer?.data?.isUpdate?.mailVerified;
  const currentPhone = user?.phone ?? data?.data?.user?.phone;
  const hasPhone = !!currentPhone?.trim();

  async function updateProfile() {
    await axiosInstance.post("/user/myprofile", { ...user });
  }

  if (!!data && !!inputAPI)
    return (
      <>
        <section className="f-list-3" style={{ marginBlock: "2rem" }}>
          <div className="container">
            <div className="bg-col">
              <div className="heder-content">
                <h6>My Account</h6>
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (isInSync) return;
                  toast.promise(profileMutation.mutateAsync(), {
                    pending: "Account is updating",
                    success: "Account updated",
                    error: "Some error has been occured ",
                  });
                }}
              >
                <div className="list-flex">
                  <div className="box  ">
                    <p>First Name *</p>

                    <input
                      type="name"
                      name="firstName"
                      defaultValue={data?.data?.user?.firstName}
                      className="input"
                      required
                      onChange={ChangeInput}
                      disabled={isLoading}
                      maxLength={60}
                    />
                  </div>
                  <div className="box ">
                    <p>Last name *</p>

                    <input
                      type="name"
                      defaultValue={data?.data?.user?.lastName}
                      name="lastName"
                      className="input"
                      required
                      disabled={isLoading}
                      onChange={ChangeInput}
                      maxLength={60}
                    />
                  </div>
                  <div className="box ">
                    <p>Email *</p>

                    <input
                      type="email"
                      name="email"
                      defaultValue={data?.data?.user?.email}
                      className="input"
                      onChange={ChangeInput}
                      required
                      disabled={isLoading}
                      maxLength={60}
                    />
                    <div class="subtitle">
                      {mailVerified ? (
                        <div
                          class="checkbox"
                          style={{
                            display: "flex",
                            gap: ".5rem",
                            cursor: !mailVerified && "pointer",
                          }}
                          onClick={() => {
                            if (!mailVerified) handleScrollDown();
                          }}
                        >
                          <label
                            style={{
                              fontSize: "1.2rem",
                              marginRight: "2rem",
                              cursor: !mailVerified && "pointer",
                            }}
                          >
                            Email Confirmed
                          </label>
                          <input
                            type="checkbox"
                            id="vehicle2"
                            name="vehicle2"
                            defaultValue="Car"
                            checked={freelancer?.data?.isUpdate?.mailVerified}
                            readOnly
                            style={{ cursor: !mailVerified && "pointer" }}
                          />
                        </div>
                      ) : (
                        <VerifyEmailButton />
                      )}
                    </div>
                  </div>
                </div>
                <div className="list-flex">
                  <div className="box ">
                    <p>Phone (optional)</p>

                    <input
                      type="name"
                      name="phone"
                      defaultValue={data?.data?.user?.phone}
                      className="input"
                      onChange={ChangeInput}
                      disabled={isLoading}
                      maxLength={60}
                      placeholder="Enter phone number"
                    />
                    <div class="subtitle">
                      <div>
                        <label
                          htmlFor="publicshow"
                          style={{
                            fontSize: "1.2rem",
                            marginRight: "2rem",
                            textAlign: "end",
                          }}
                        >
                          Show phone to public
                        </label>
                        <input
                          type="checkbox"
                          id="publicshow"
                          name="publicshow"
                          defaultValue="Car"
                          defaultChecked={data?.data?.user?.showPhonePublic}
                          disabled={!hasPhone}
                          onChange={(e) =>
                            setUser((user) => ({
                              ...user,
                              showPhonePublic: e.target.checked,
                            }))
                          }
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="regshow"
                          style={{
                            fontSize: "1.2rem",
                            marginRight: "2rem",
                            textAlign: "end",
                          }}
                        >
                          Show phone to registered users
                        </label>
                        <input
                          type="checkbox"
                          id="regshow"
                          name="regshow"
                          defaultValue="Car"
                          defaultChecked={data?.data?.user?.showPhoneRegistered}
                          disabled={!hasPhone}
                          onChange={(e) =>
                            setUser((user) => ({
                              ...user,
                              showPhoneRegistered: e.target.checked,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box ">
                    <p>Country *</p>

                    <select
                      style={{
                        backgroundColor:
                          inputIsLoading || isLoading ? "#cacaca" : "#cacaca",
                      }}
                      name="country"
                      defaultValue={data?.data?.user?.country}
                      className="input"
                      required
                      onChange={ChangeInput}
                      disabled={isLoading || inputIsLoading}
                    >
                      {inputAPI?.country?.map((val) => (
                        <>
                          <option key={val} value={val}>
                            {val}
                          </option>
                          {val == "Yemen" && (
                            <option value="" disabled="disabled">
                              ------------------------------------------------------------------------------
                            </option>
                          )}
                        </>
                      ))}
                    </select>
                  </div>
                  <div className="box ">
                    <p>City *</p>

                    <input
                      type="name"
                      name="city"
                      className="input"
                      onChange={ChangeInput}
                      //   placeholder="Performance"
                      disabled={isLoading}
                      defaultValue={data?.data?.user?.city}
                      required
                    />
                  </div>
                </div>

                <div className="heder-content">
                  {/* <h6>Manage Profile</h6> */}
                  <div
                    className="a-btns"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: "#00000000",
                        border: "0px solid black",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      {/* <a href="#">Preview Profile</a> */}
                      <a
                        style={{
                          backgroundColor: isInSync && "#909090",
                          border: `1px solid #909090`,
                        }}
                      >
                        Save Account
                      </a>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </>
    );
}

function Password() {
  const { data, isLoading, error } = fetchProfile();
  const navigate = useNavigate();
  const [input, setInput] = useState({
    current: ``,
    new: "",
    newConfirm: "",
  });
  // if (data && !user) {
  //   setUser(data?.data?.user);
  // }

  async function updatePwd() {
    await axiosInstance.post("/user/password/update", input);
  }
  const profileMutation = useMutation(updatePwd, {
    onSuccess: () => {
      toast.success("Password updated");
    },
    onError: (e) => {
      if (e?.response?.data?.errors?.error == "invalidCurrentPwd")
        return toast.error("Invalid current password");

      toast.error("Some error occured");
    },
  });

  function changeInput(e) {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const allFilled = input.current && input.new && input.newConfirm;
  const pwdIsEql = input.new == input.newConfirm;
  const newIsSame = input.current == input.new;

  return (
    <>
      <section className="f-list-3" style={{ marginBlock: "2rem" }}>
        <div className="container">
          <div className="bg-col">
            <div className="heder-content">
              <h6>Password</h6>
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();

                if (!allFilled)
                  return toast.warning("Please enter all fields.");

                if (!pwdIsEql)
                  return toast.warning("Passwords does not match.");

                if (newIsSame)
                  return toast.warning(
                    "New password cannot be same as the old one."
                  );

                profileMutation.mutate();
              }}
            >
              <div className="list-flex">
                <div className="box  ">
                  <p>Current Password</p>

                  <input
                    type="password"
                    name="current"
                    className="input"
                    value={input.current}
                    onChange={changeInput}
                    placeholder="Enter your current password here."
                  />
                  <div>
                    <a
                      onClick={() => navigate("/forgot")}
                      style={{
                        fontSize: "1.1rem",
                        cursor: "pointer",
                        color: "blue",
                      }}
                    >
                      Forgot your password?
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-flex">
                <div className="box  ">
                  <p>New Password</p>

                  <input
                    type="password"
                    name="new"
                    className="input"
                    value={input.new}
                    onChange={changeInput}
                    placeholder="Enter your new password here."
                  />
                </div>
                <div className="box  ">
                  <p>Confirm New password</p>

                  <input
                    type="password"
                    name="newConfirm"
                    className="input"
                    value={input.newConfirm}
                    onChange={changeInput}
                    placeholder="Please confirm your new password."
                  />
                </div>
              </div>
              {!pwdIsEql && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    width: "100%",
                    color: "red",
                    fontSize: "1.3rem",
                    marginRight: "2rem",
                  }}
                >
                  <label>Please check the typed data</label>
                </div>
              )}
              <div className="heder-content">
                {/* <h6>Manage Profile</h6> */}
                <div
                  className="a-btns"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#00000000",
                      border: "0px solid black",
                      padding: "0px",
                      margin: "0px",
                    }}
                  >
                    <a
                      style={{
                        backgroundColor: (!allFilled || !pwdIsEql) && "#909090",
                        border: `1px solid #909090`,
                      }}
                    >
                      Save Password
                    </a>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

function DeleteAccount() {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  const deleteMutation = useMutation(
    async () => await axiosInstance.post("/user/delete-account"),
    {
      onSuccess: () => {
        localStorage.removeItem("Auth");
        queryClient.clear();
        toast.success("Your account has been deleted.");
        navigate("/login");
      },
      onError: () => {
        toast.error("Failed to delete account. Please try again.");
      },
    }
  );

  return (
    <>
      <section className="f-list-3" style={{ marginBlock: "2rem" }}>
        <div className="container">
          <div className="bg-col">
            <div className="heder-content">
              <h6>Delete Account</h6>
            </div>
            <p style={{ marginBottom: "1.5rem", lineHeight: 1.6 }}>
              Permanently remove your account from the platform. Your profile
              and posted vacancies will no longer be visible to other users.
              You will be logged out immediately and will not be able to sign in
              again.
            </p>
            <button
              type="button"
              onClick={() => setShowConfirm(true)}
              style={{
                backgroundColor: "#c0392b",
                color: "#fff",
                border: "none",
                padding: "0.75rem 1.5rem",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "1rem",
              }}
            >
              Delete Account
            </button>
          </div>
        </div>
      </section>

      {showConfirm && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2rem",
              borderRadius: "8px",
              maxWidth: "28rem",
              width: "90%",
            }}
          >
            <h6 style={{ marginBottom: "1rem" }}>Delete your account?</h6>
            <p style={{ marginBottom: "1.5rem", lineHeight: 1.6 }}>
              This action cannot be undone. Your account will be deactivated and
              you will be logged out immediately.
            </p>
            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "flex-end",
              }}
            >
              <button
                type="button"
                onClick={() => setShowConfirm(false)}
                disabled={deleteMutation.isLoading}
                style={{
                  padding: "0.6rem 1.2rem",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
              >
                No
              </button>
              <button
                type="button"
                onClick={() => deleteMutation.mutate()}
                disabled={deleteMutation.isLoading}
                style={{
                  padding: "0.6rem 1.2rem",
                  border: "none",
                  borderRadius: "4px",
                  backgroundColor: "#c0392b",
                  color: "#fff",
                  cursor: deleteMutation.isLoading ? "not-allowed" : "pointer",
                }}
              >
                {deleteMutation.isLoading ? "Deleting..." : "Yes, delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Container;
